"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var RadioButton = function RadioButton(props) {
  return /*#__PURE__*/React.createElement("label", {
    "data-aid": props.automationId,
    "data-hook": props.dataHook,
    className: props.getClassName('radio-button-wrapper') + ' ' + _({
      selected: props.selected,
      disabled: props.disabled
    }).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' ')
  }, /*#__PURE__*/React.createElement("input", {
    className: "input",
    type: "radio",
    name: props.name,
    value: props.value,
    readOnly: true,
    checked: props.selected,
    disabled: props.disabled,
    onClick: props.disabled ? _.noop : props.onChange
  }), props.showRadioSymbol ? /*#__PURE__*/React.createElement("div", {
    key: "radio-symbol",
    className: "radio-button-symbol"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-fill"
  })) : null, props.children);
};

RadioButton.displayName = displayNames.RADIO_BUTTON;
RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  showRadioSymbol: PropTypes.bool
};
RadioButton.defaultProps = {
  selected: false,
  disabled: false,
  showRadioSymbol: true
};
module.exports = compose(RadioButton);